export default "__VITE_ASSET__26764010__"